import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectMicrositeTrackingState = createFeatureSelector<
  MicrositeTrackingState
>('micrositeTracking');

import { MicrositeTrackingState } from './coreTracking.models';

export const selectTracking = createSelector(
  selectMicrositeTrackingState,
  (state: MicrositeTrackingState) => state
);
